<template>
  <div class="ev-inconsistences-container no-print">
    <!-- Radnici sa prekovremenim satima kao ukupnim satima -->
    <div
      class="ev-inconsistence-section ev-inconsistence-section--warning"
      v-if="logsWithOvertimeInconsistence.length > 0"
    >
      <div class="ev-inconsistence-header">
        <span class="ev-inconsistence-icon">⚠️</span>
        <h4 class="ev-inconsistence-title">
          Prekovremeni sati isti kao ukupni sati
        </h4>
        <span class="ev-inconsistence-count">{{
          logsWithOvertimeInconsistence.length
        }}</span>
      </div>
      <div class="ev-inconsistence-cards">
        <div
          @contextmenu.prevent="absentEmployeeClicked(emp, $event)"
          class="ev-inconsistence-card ev-inconsistence-card--warning"
          v-for="emp in logsWithOvertimeInconsistence"
          :key="emp.id"
        >
          <span class="ev-card-name">{{ emp.name }}</span>
        </div>
      </div>
    </div>

    <!-- Radnici sa radom preko 12h -->
    <div
      class="ev-inconsistence-section ev-inconsistence-section--info"
      v-if="logsWithIncorrectDeparture.length > 0"
    >
      <div class="ev-inconsistence-header">
        <span class="ev-inconsistence-icon">🕐</span>
        <h4 class="ev-inconsistence-title">Radili preko 12 sati</h4>
        <span class="ev-inconsistence-count">{{
          logsWithIncorrectDeparture.length
        }}</span>
      </div>
      <div class="ev-inconsistence-cards">
        <div
          @contextmenu.prevent="absentEmployeeClicked(emp, $event)"
          class="ev-inconsistence-card ev-inconsistence-card--info"
          :style="{
            'border-left-color': getBorderColorFromWorkhours(
              emp.totalWorkhoursThisDay,
              288000000000,
              576000000000
            ),
          }"
          v-for="emp in logsWithIncorrectDeparture"
          :key="emp.id"
        >
          <span class="ev-card-name">{{ emp.name }}</span>
          <span class="ev-card-time">{{ worktimeSpan(emp) }}</span>
          <span
            class="ev-card-hours"
            :style="{
              color: getBorderColorFromWorkhours(
                emp.totalWorkhoursThisDay,
                288000000000,
                576000000000
              ),
            }"
            >{{ workhoursData(emp) }}</span
          >
        </div>
      </div>
    </div>

    <!-- Radnici sa radom manje od 6h -->
    <div
      class="ev-inconsistence-section ev-inconsistence-section--info"
      v-if="logsWithIncorrectArrival.length > 0"
    >
      <div class="ev-inconsistence-header">
        <span class="ev-inconsistence-icon">⏱️</span>
        <h4 class="ev-inconsistence-title">Radili manje od 6 sati</h4>
        <span class="ev-inconsistence-count">{{
          logsWithIncorrectArrival.length
        }}</span>
      </div>
      <div class="ev-inconsistence-cards">
        <div
          @contextmenu.prevent="absentEmployeeClicked(emp, $event)"
          class="ev-inconsistence-card ev-inconsistence-card--info"
          :style="{
            'border-left-color': getBorderColorFromWorkhours(
              emp.totalWorkhoursThisDay,
              288000000000,
              36000000000
            ),
          }"
          v-for="emp in logsWithIncorrectArrival"
          :key="emp.id"
        >
          <span class="ev-card-name">{{ emp.name }}</span>
          <span class="ev-card-time">{{ worktimeSpan(emp) }}</span>
          <span
            class="ev-card-hours"
            :style="{
              color: getBorderColorFromWorkhours(
                emp.totalWorkhoursThisDay,
                288000000000,
                36000000000
              ),
            }"
            >{{ workhoursData(emp) }}</span
          >
        </div>
      </div>
    </div>

    <!-- Radnici sa ekstremnim kašnjenjem -->
    <div
      class="ev-inconsistence-section ev-inconsistence-section--purple"
      v-if="logsWithExtremelate.length > 0"
    >
      <div class="ev-inconsistence-header">
        <span class="ev-inconsistence-icon">⏰</span>
        <h4 class="ev-inconsistence-title">Ekstremno kašnjenje</h4>
        <span class="ev-inconsistence-count">{{
          logsWithExtremelate.length
        }}</span>
      </div>
      <div class="ev-inconsistence-cards">
        <div
          @contextmenu.prevent="absentEmployeeClicked(emp, $event)"
          class="ev-inconsistence-card ev-inconsistence-card--purple"
          :style="{
            'border-left-color': getBorderColorFromWorkhours(
              emp.lateWorkhours,
              15000000000,
              36000000000
            ),
          }"
          v-for="emp in logsWithExtremelate"
          :key="emp.id"
        >
          <span class="ev-card-name">{{ emp.name }}</span>
          <span class="ev-card-time">{{ worktimeSpan(emp) }}</span>
          <span
            class="ev-card-hours"
            :style="{
              color: getBorderColorFromWorkhours(
                emp.lateWorkhours,
                15000000000,
                36000000000
              ),
            }"
            >{{ lateWorkhoursData(emp) }}</span
          >
        </div>
      </div>
    </div>

    <!-- Radnici sa dvokratnim radnim vremenom -->
    <div
      class="ev-inconsistence-section ev-inconsistence-section--success"
      v-if="logsWithTooLongOutsideEvent.length > 0"
    >
      <div class="ev-inconsistence-header">
        <span class="ev-inconsistence-icon">🚶</span>
        <h4 class="ev-inconsistence-title">
          Predugačak izlazak (dvokratno radno vrijeme?)
        </h4>
        <span class="ev-inconsistence-count">{{
          logsWithTooLongOutsideEvent.length
        }}</span>
      </div>
      <div class="ev-inconsistence-cards">
        <div
          @contextmenu.prevent="absentEmployeeClicked(emp, $event)"
          class="ev-inconsistence-card ev-inconsistence-card--success"
          :style="{
            'border-left-color': getBorderColorFromWorkhours(
              emp.lateWorkhours,
              15000000000,
              36000000000
            ),
          }"
          v-for="emp in logsWithTooLongOutsideEvent"
          :key="emp.id"
        >
          <span class="ev-card-name">{{ emp.name }}</span>
          <span class="ev-card-time">{{ worktimeSpan(emp) }}</span>
          <span
            class="ev-card-hours"
            :style="{
              color: getBorderColorFromWorkhours(
                emp.lateWorkhours,
                15000000000,
                36000000000
              ),
            }"
            >{{ lateWorkhoursData(emp) }}</span
          >
        </div>
      </div>
    </div>

    <!-- contex menu -->
    <context-menu-max :display="showContextMenu" ref="menu">
      <ul class="ev-context-menu-list">
        <li
          v-show="showContextMenuDeactivate"
          @click="cmResolve"
          class="ev-context-menu-item ev-context-menu-item--success"
        >
          <span class="ev-context-icon">🔍</span>
          Vidi detalje...
        </li>
        <li
          v-show="showContextMenuDeactivateAll"
          @click="cmResolve"
          class="ev-context-menu-item"
        >
          <span class="ev-context-icon">📅</span>
          Svi u neradni dan!
        </li>
      </ul>
    </context-menu-max>
  </div>
</template>

<script>
import ContextMenuMax from "./ContextMenu.vue";

import {
  // getShortTimeFromTicks,
  getDateFromTicks,
  maskIfEquealsValue,
} from "../../_helpers/arrangers";

import getColorFromTicks from "../../_helpers/ticksToColor";
import { call } from "../../_helpers/parallelNormalizedAccessCaller";

export default {
  name: "InconsistencesView",
  props: {
    date: Date,
    tomorrow: Date,
    logs: [],
  },

  components: {
    ContextMenuMax,
  },

  data() {
    return {
      selectedEmplyoee: null,
      logsWithOvertimeInconsistence: [],
      logsWithIncorrectDeparture: [],
      logsWithIncorrectArrival: [],
      logsWithExtremelate: [],
      logsWithTooLongOutsideEvent: [],
      showContextMenuDeactivateAll: true,
      showContextMenuDeactivate: true,
      showContextMenu: false,
    };
  },

  watch: {
    logs: {
      handler() {
        this.extractBadLogs();
      },
    },
  },

  mounted() {
    this.extractBadLogs();
  },

  methods: {
    getBorderColorFromWorkhours(workhours, start_00, stop_FF) {
      const color = getColorFromTicks(workhours, "00", "FF", start_00, stop_FF);
      return color;
    },

    worktimeSpan(log) {
      let start =
        log.arrivalTimeGeneral !== undefined
          ? log.arrivalTimeGeneral.split("T")[1]
          : "❓";

      let stop =
        log.departureTimeGeneral !== undefined
          ? log.departureTimeGeneral.split("T")[1]
          : "❓";

      return start + " - " + stop;
    },

    workhoursData(log) {
      return (
        "Ukupno " +
        maskIfEquealsValue(
          getDateFromTicks(log.totalWorkhoursThisDay),
          "00:00:00"
        )
      );
    },

    lateWorkhoursData(log) {
      return (
        "Kašnjenje " +
        maskIfEquealsValue(getDateFromTicks(log.lateWorkhours), "00:00:00")
      );
    },

    extractBadLogs() {
      this.logsWithOvertimeInconsistence =
        this.extractLogsWithOvertimeInconsistence(this.logs);
      this.logsWithIncorrectDeparture = this.extractLogsWithBadDeparture(
        this.logs
      );
      this.logsWithIncorrectArrival = this.extractLogsWithBadArrival(this.logs);
      this.logsWithExtremelate = this.extractLogsWithExtreemLate(this.logs);
      this.logsWithTooLongOutsideEvent =
        this.extractlogsWithTooLongOutsideEvent(this.logs);

      this.resolveLogsWithOvertimeInconsistence(
        this.logsWithOvertimeInconsistence
      );
    },

    resolveLogsWithOvertimeInconsistence(logs) {
      let employeeIds = [];
      if (logs !== undefined) {
        logs.forEach((log) => {
          employeeIds.push(log.employeeId);
        });
        console.log("resolving logs with overtime inconsistence", logs);
        call(this.date, this.tomorrow, employeeIds);
      }
    },

    extractlogsWithTooLongOutsideEvent(logs) {
      let returnLogs = [];

      logs.forEach((lg) => {
        lg.outsideEvent.forEach((oe) => {
          // let start = new Date(oe.arrivalTime);
          // let stop =
          if (
            oe.isLogicallyClosed === true &&
            oe.duration > 144000000000 && // 4h
            oe.leavingReasonId == null &&
            oe.routeName == "" &&
            new Date(oe.arrivalTime) >
              new Date(oe.arrivalTime.split("T")[0] + "T18:00:00")
          ) {
            returnLogs.push(lg);
          }
        });
      });

      return returnLogs;
    },

    extractLogsWithOvertimeInconsistence(logs) {
      const filteredLogs = logs.filter(
        (l) =>
          (l.overtimeWorkhours === l.totalWorkhoursThisDay &&
            l.overtimeWorkhours > 0 &&
            l.statusId === 1) ||
          l.statusId == null
      );
      return filteredLogs;
    },

    extractLogsWithBadDeparture(logs) {
      const filteredLogs = logs.filter(
        (l) => l.totalWorkhoursThisDay > 440000000000
      );
      //   console.log("overtime inconsistence:");
      //   console.log(filteredLogs);
      return filteredLogs;
    },

    extractLogsWithBadArrival(logs) {
      const filteredLogs = logs.filter(
        (l) =>
          l.totalWorkhoursThisDay < 216000000000 && l.totalWorkhoursThisDay > 0
      );
      return filteredLogs;
    },

    extractLogsWithExtreemLate(logs) {
      const filteredLogs = logs.filter((l) => l.lateWorkhours > 18000000000);
      logs.forEach((element) => {
        console.log(element.lateType);
        console.log(element.name);
        if (element.name === "Tatjana Čađenović") {
          console.log(element);
        }
      });
      return filteredLogs;
    },

    absentEmployeeClicked(emp, event) {
      this.showContextMenuDeactivate = true;
      this.showContextMenuDeactivateAll = false;
      this.selectedEmplyoee = emp;
      console.log(emp);
      console.log(event);
      this.$refs.menu.open(event);
    },

    cmResolve() {
      console.log("resolving!");
      console.log(this.selectedEmplyoee.firstName);
      const theDate = new Date(
        this.date.getTime() - this.date.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];

      this.$router.push(
        "/user/ManualFix?date=" +
          theDate +
          "&employeeId=" +
          this.selectedEmplyoee.employeeId
      );
    },
  },
};
</script>

<style scoped>
/* Inconsistences Container */
.ev-inconsistences-container {
  display: flex;
  flex-direction: column;
  gap: var(--ev-spacing-md);
  margin-bottom: var(--ev-spacing-lg);
}

/* Section Styles */
.ev-inconsistence-section {
  background: white;
  border-radius: var(--ev-radius-lg);
  overflow: hidden;
  box-shadow: var(--ev-shadow);
}

.ev-inconsistence-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-bottom: 1px solid var(--ev-border);
}

.ev-inconsistence-section--warning .ev-inconsistence-header {
  background: linear-gradient(135deg, #fef9c3 0%, #fef3c7 100%);
}

.ev-inconsistence-section--info .ev-inconsistence-header {
  background: linear-gradient(135deg, #cffafe 0%, #e0f2fe 100%);
}

.ev-inconsistence-section--purple .ev-inconsistence-header {
  background: linear-gradient(135deg, #f3e8ff 0%, #ede9fe 100%);
}

.ev-inconsistence-section--success .ev-inconsistence-header {
  background: linear-gradient(135deg, #dcfce7 0%, #d1fae5 100%);
}

.ev-inconsistence-icon {
  font-size: 20px;
}

.ev-inconsistence-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--ev-text-primary);
  flex: 1;
}

.ev-inconsistence-count {
  background: rgba(0, 0, 0, 0.1);
  color: var(--ev-text-secondary);
  padding: 4px 12px;
  border-radius: var(--ev-radius-full);
  font-size: 13px;
  font-weight: 600;
}

/* Cards Container */
.ev-inconsistence-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 16px 20px;
}

/* Individual Cards */
.ev-inconsistence-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  border-radius: var(--ev-radius);
  min-width: 150px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 4px solid transparent;
}

.ev-inconsistence-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--ev-shadow-md);
}

.ev-inconsistence-card--warning {
  background: #fffbeb;
  border-left-color: #f59e0b;
}

.ev-inconsistence-card--info {
  background: #ecfeff;
}

.ev-inconsistence-card--purple {
  background: #faf5ff;
}

.ev-inconsistence-card--success {
  background: #f0fdf4;
}

.ev-card-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--ev-text-primary);
}

.ev-card-time {
  font-size: 12px;
  color: var(--ev-text-muted);
}

.ev-card-hours {
  font-size: 12px;
  font-weight: 700;
}
</style>